'use client'

import { useContext, useEffect, useReducer, useRef, useState } from 'react'
import { getErrorMessages } from 'utils/src/api'
import { Button, Form } from '@/components/auth/sc'
import { FlashMessageContext } from '@/context/flash-message'
import { getCookie } from '@/util/url'
import { CSRF_COOKIE_NAME, CSRF_HEADER_NAME } from '@/util/user'
import { giphyLocalUrl } from '@/app/util/env'
import { timeoutFetch } from 'utils/src/api/fetch'

const PasswordResetForm = () => {
    const form = useRef<HTMLFormElement>(null)
    const [loading, setLoading] = useState(false)
    const [csrftoken, setCSRFToken] = useState('')
    const [, forceUpdate] = useReducer((x) => x + 1, 0)
    const emailInput = useRef<HTMLInputElement>(null)
    const { showMessage } = useContext(FlashMessageContext)
    useEffect(() => {
        setCSRFToken(getCookie(CSRF_COOKIE_NAME))
    }, [])
    const sendResetRequest = async () => {
        setLoading(true)
        try {
            const result = await timeoutFetch({
                url: `${giphyLocalUrl}/api/v3/password/reset`,
                options: {
                    method: 'POST',
                    body: new FormData(form.current!),
                    headers: {
                        [CSRF_HEADER_NAME]: csrftoken,
                    },
                },
                timeout: 5000,
            })
            const response = await result.json()
            if (result.ok) {
                showMessage({
                    message: response.detail,
                    type: 'success',
                })
            } else {
                showMessage({
                    message: getErrorMessages(response),
                    type: 'error',
                })
            }
        } catch (error) {
            console.error('Unspecified error', error)
        }
        setLoading(false)
    }
    return (
        <Form ref={form} noValidate>
            <div>
                <input type="hidden" name="platform" value="web" />
                <input placeholder="email" name="email" required type="email" ref={emailInput} onInput={forceUpdate} className="bg-giphyWhite placeholder-inputPlaceholder" />
                <div className="error-message">{emailInput.current?.validationMessage}</div>
            </div>
            <Button
                size="medium"
                gradient="purple-indigo"
                disabled={!form.current?.checkValidity()}
                onClick={sendResetRequest}
                loading={loading}
            >
                Send Email
            </Button>
        </Form>
    )
}

export default PasswordResetForm
